import { render } from "./ShoppingListRecommendationPageIndicator.vue?vue&type=template&id=604a038a&scoped=true&ts=true"
import script from "./ShoppingListRecommendationPageIndicator.vue?vue&type=script&lang=ts"
export * from "./ShoppingListRecommendationPageIndicator.vue?vue&type=script&lang=ts"

import "./ShoppingListRecommendationPageIndicator.vue?vue&type=style&index=0&id=604a038a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604a038a"]])

export default __exports__